import { MESSAGE_BAR_TYPES } from "../../utils/constants";
import { getFiatServices, getDashboardDataAPI, logFeedBackOpenTimeApi } from "../api";
import {
  SET_DASHBOARD_DATA,
  SET_DASHBOARD_DATA_DEFAULT,
  SET_FIAT_SERVICE,
  SHOW_MESSAGE,
} from "./actionTypes";

export const getDashboardData = () => async (dispatch) => {
  try {
    const response = await getDashboardDataAPI();
    await dispatch({
      type: SET_DASHBOARD_DATA,
      payload: response.result,
    });
  } catch (err) {
    dispatch({
      type: SET_DASHBOARD_DATA_DEFAULT,
      payload: null,
    });
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message,
      },
    });
  }
};

export const logFeedBackTime = () => async (dispatch) => {
  try {
    await logFeedBackOpenTimeApi();
  } catch (err) {
    //to-do
  }
};

export const getSerivceProvider = (country, currency, onSuccess) => async (dispatch) => {
  try {
    const response = await getFiatServices(country, currency);
    await dispatch({
      type: SET_FIAT_SERVICE,
      payload: response.result,
    });
    if (typeof onSuccess === 'function') onSuccess();
  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message,
      },
    });
  }
}